import { render, staticRenderFns } from "./PickUpGoods.vue?vue&type=template&id=5966bd3a&scoped=true"
import script from "./PickUpGoods.vue?vue&type=script&lang=js"
export * from "./PickUpGoods.vue?vue&type=script&lang=js"
import style0 from "./PickUpGoods.vue?vue&type=style&index=0&id=5966bd3a&prod&lang=scss&scoped=true"
import style1 from "./PickUpGoods.vue?vue&type=style&index=1&id=5966bd3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966bd3a",
  null
  
)

export default component.exports